<template>
  <div class="banner">
    <marquee :scrollamount="scrollSpeed">
      {{message}}
    </marquee>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    scrollSpeed: {
      type: String,
      default: "5"
    }
  }
}
</script>

<style scoped>
.banner {
  position: relative;
  top: 64px;
  left: 80px;
  padding: 0.25rem;
  color: var(--v-bg-base);
  background: var(--v-accent-base);
  font-weight: bold;
}
</style>
